import produce from 'immer';
import {
  GET_USER,
  GET_USER_CONVERSATIONS_LIST,
  SET_PAGE,
  UPDATE_CONVERSATION_MESSAGES,
  GET_USER_CONVERSATION,
  SET_CURRENT_CHANNEL,
  CLEAR_USER_CONVERSATION,
  SET_SERVER_MESSAGES_QUEUE,
  GET_INITIAL_STATE,
  SET_USER_CONVERSATION_DATA,
  SET_USER_ID,
  SET_PRIMARY_COLOR,
  SET_SECONDARY_COLOR,
  SET_LOGO_URL,
  SET_BOT_NAME,
  SET_HIDE_COMPANY_DETAILS_IN_WIDGET,
  SET_NETWORK_STATUS,
  UPDATE_SENDING_MESSAGES,
  CLEAR_ACTIVE_MESSAGES,
  CREATE_NEW_CONVERSATION,
  SET_PARENT_INNER_WIDTH,
  SET_POPUP_TO_NOTIFICATION_MESSAGE,
  SET_INPUT_BOX_STATUS,
  SET_TIME_SPENT,
  SET_AGENT,
  SET_EXTERNAL_TRIGGER_FORMS,
  SET_EXTERNAL_TRIGGER_ELEMENTS,
  SET_IS_MESSAGE_UNREAD,
  SET_IS_PUSHER_CONNECTED,
  SET_READ_NOTIFICATION,
  SET_ACTIVE_PAGE,
  SET_AGENT_NEW_MESSAGE_LIST,
  SET_WIDGET_VISIBILITY,
  WIDGET_SOUND,
  TEXT_AREA_NUMBER_OF_LINES,
  CLEAR_BOT_ACTIVE_PATH,
  SET_SHOW_TYPING,
  SHOW_TYPING_INDICATOR,
  SET_CLIENT_SENT_TIME,
  SET_SERVER_RESPONSE_TIME,
  RESET_NETWORK_DELAY,
  SET_TAB_ID,
  SET_LINK_IFRAME,
  SET_INITIATE_SOCKET_CONNECTION,
  SET_DELAY_FLAG,
  SET_SEND_GREETING_MESSAGE_ACTION,
  SET_LANGUAGE,
  HIDE_RESTART_BUTTON,
  SET_USER_ATTACHMENTS,
  REMOVE_FROM_CONVERSATION_MESSAGES,
  SET_MAPPED_FORM_FIELDS,
  SET_CUSTOM_COOKIES,
  GET_SEARCHED_GIFS, GET_TRENDING_GIFS, GET_RECENT_GIFS,
} from './constants';

export const initialState = {
  frameSize: {
    parentInnerWidth: false,
    parentInnerHeight: false,
  },
  currentPage: '',
  notificationRead: 0,
  agentNewMessageList: [],
  widgetVisibility: true,
  widgetSound: true,
  config: {
    projectKey: false,
    blogUrl: false,
    botName: false,
    hideCompanyDetailsInWidget: false,
    eventListenerName: false,
    userId: false,
  },
  delayFlag: false,
  user: {
    loading: false,
    error: false,
    data: {},
  },
  externalTriggers: {
    forms: [],
    elements: [],
    formFields: []
  },
  customCookies: [],
  conversation: {
    loading: true,
    error: false,
    data: {},
    messages: [],
    sendingMessages: [],
    isTyping: false,
  },
  userAttachments: [],
  serverMessagesQueue: [],
  showTypingIndicator: false,
  currentChannel: undefined,
  InitiateSocketConnection: false,
  greetingMessageAction: {},
  newConversation: {
    loading: false,
    error: false,
    data: {},
  },
  // we are not using this anywhere
  conversations: {
    loading: false,
    error: false,
    data: {},
  },
  networkStatus: 'online',
  popupToNotificationMessage: '',
  timeSpent: {
    loading: false,
    error: false,
  },
  agent: {
    agentId: null,
    name: null,
  },
  isPusherConnected: false,
  isMessageUnread: false,
  textAreaNumberOfLines: 1,
  clearBotActivePath: false,
  networkDelay: {
    sentTime: null,
    responseTime: null,
  },
  hideRestartButton: false,
  language:{
  },
  gifs: {
    recent: {
      loading: false,
      data: [],
    },
    trending: {
      loading: false,
      data: [],
      pagination: {},
    },
    searched: {
      loading: false,
      data: [],
      pagination: {},
    },
  },
  iframePage: {
    loading: false,
    show: false,
    link: {},
  }
};

const appReducer = (state = initialState, action) =>
  produce(state, draft => {
    switch (action.type) {
      case SET_LINK_IFRAME.START:
        draft.iframePage.loading = true;
        draft.iframePage.show = true;
        draft.iframePage.link = action.payload.link;
        break;
      case SET_LINK_IFRAME.SUCCESS:
        draft.iframePage.loading = false;
        break;
      case SET_LINK_IFRAME.ERROR:
        draft.iframePage.loading = false;
        draft.iframePage.show = false;
        draft.iframePage.link = {};
        break;

      case TEXT_AREA_NUMBER_OF_LINES:
        draft.textAreaNumberOfLines = action.payload.data;
        break;

      case RESET_NETWORK_DELAY:
        draft.networkDelay = { sentTime: null, responseTime: null };
        break;

      case SET_CLIENT_SENT_TIME:
        draft.networkDelay.sentTime = action.payload.sentTime;
        break;
      case SET_DELAY_FLAG:
        draft.delayFlag = action.payload.flag;
        break;

      case SET_SERVER_RESPONSE_TIME:
        draft.networkDelay.responseTime = action.payload.responseTime;
        break;

      case CLEAR_BOT_ACTIVE_PATH:
        draft.clearBotActivePath = action.payload.value;
        break;
      case SET_SHOW_TYPING:
        draft.conversation.isTyping = action.payload.isTyping;
        break;
      case SHOW_TYPING_INDICATOR:
        draft.showTypingIndicator = action.payload.showTypingIndicator;
        break;
      case SET_WIDGET_VISIBILITY:
        draft.widgetVisibility = action.meta.widgetVisibility;
        break;
      case GET_INITIAL_STATE.SUCCESS:
        draft.config.projectKey = action.payload.data && action.payload.data.project_key;
        draft.config.blogUrl = action.payload.data && action.payload.data.blog_url;
        draft.config.eventListenerName = action.payload.data && action.payload.data.event_listener;
        draft.config.userId = action.payload.data && action.payload.data.user_id;
        draft.frameSize.parentInnerWidth =
          action.payload.data && action.payload.data.parent_innerwidth;
        draft.frameSize.parentInnerHeight =
          action.payload.data && action.payload.data.parent_innerheight;
        draft.widgetVisibility =
          action.payload.data && action.payload.data.widgetVisibility === 'true';
        break;

      case SET_USER_ID:
        draft.config.userId = action.payload.userId;
        break;

      case SET_PRIMARY_COLOR:
        draft.user.data.settings.color.headerBackgroundColor = action.payload.primaryColor;
        break;

      case SET_SECONDARY_COLOR:
        draft.user.data.settings.color.headerTextColor  = action.payload.secondaryColor;
        break;

      case SET_LOGO_URL:
        draft.user.data.settings.bot.img =  action.payload.logoUrl;
        draft.user.data.settings.bot.widgetIcon =  action.payload.logoUrl;
        draft.user.data.settings.bot.overrideLogo = action.payload.logoUrl;
        break;

      case SET_LANGUAGE:
        draft.language = action.payload.language;
        break;

      case SET_BOT_NAME:
        draft.config.botName = action.payload.botName;
        break;

      case SET_HIDE_COMPANY_DETAILS_IN_WIDGET:
        draft.config.hideCompanyDetailsInWidget = action.payload.hideCompanyDetailsInWidget;
        break;

      case SET_PAGE:
        draft.currentPage = action.meta.page;
        break;

      case SET_SEND_GREETING_MESSAGE_ACTION:
        draft.greetingMessageAction = action.meta.message;
        break;

      case SET_ACTIVE_PAGE.SUCCESS:
        draft.currentPage = action.meta.page;
        break;
      case SET_READ_NOTIFICATION:
        draft.notificationRead = action.meta.data;
        break;
      case SET_AGENT_NEW_MESSAGE_LIST:
        draft.agentNewMessageList = action.meta.data;
        break;
      case SET_EXTERNAL_TRIGGER_FORMS:
        draft.externalTriggers.forms = action.payload.forms;
        break;
      case SET_EXTERNAL_TRIGGER_ELEMENTS:
        draft.externalTriggers.elements = action.payload.elements;
        break;
      case SET_MAPPED_FORM_FIELDS:
        draft.externalTriggers.formFields = action.payload.formFields;
        break;
      case SET_CUSTOM_COOKIES:
        draft.customCookies = action.payload.customCookies;
        break;
      case SET_IS_MESSAGE_UNREAD:
        draft.isMessageUnread = action.payload.status;
        break;
      case SET_USER_ATTACHMENTS:
        draft.userAttachments = action.payload && action.payload.attachments;
        break;
      case SET_IS_PUSHER_CONNECTED:
        draft.isPusherConnected = action.payload.status;
        break;
      case WIDGET_SOUND:
        draft.widgetSound = action.meta.status;
        break;

      case GET_USER.START:
        draft.user.loading = true;
        break;

      case HIDE_RESTART_BUTTON:
        draft.hideRestartButton = action.payload.hideRestartButton;
        break;

      case GET_USER.SUCCESS:
        draft.user.loading = false;
        draft.user.error = false;
        draft.user.data = action.payload.data;
        break;

      case GET_USER.ERROR:
        draft.user.loading = false;
        draft.user.error = action.error;
        break;

      case GET_USER_CONVERSATIONS_LIST.START:
        draft.conversations.loading = true;
        break;

      case SET_SERVER_MESSAGES_QUEUE:
        draft.serverMessagesQueue = action.payload.messageQueue;
        break;

      case GET_USER_CONVERSATIONS_LIST.SUCCESS:
        draft.conversations.loading = false;
        draft.conversations.error = false;
        draft.conversations.data = action.payload.data;
        break;

      case GET_USER_CONVERSATIONS_LIST.ERROR:
        draft.conversations.loading = false;
        draft.conversations.error = action.error;
        break;

      case GET_USER_CONVERSATION.START:
        draft.conversation.loading = true;
        draft.conversation.messages = [];
        draft.conversation.data = {};
        break;

      case GET_USER_CONVERSATION.SUCCESS:
        draft.conversation.loading = false;
        draft.conversation.error = false;
        draft.conversation.data = action.payload.data;
        if (action.payload.data.prevMessages)
          draft.conversation.messages = action.payload.data.prevMessages;
        break;

      case GET_USER_CONVERSATION.ERROR:
        draft.conversation.loading = false;
        draft.conversation.error = action.error;
        break;

      case CREATE_NEW_CONVERSATION.START:
        draft.conversation.loading = true;
        break;

      case UPDATE_CONVERSATION_MESSAGES.SUCCESS:
        draft.conversation.messages = action.payload.messages;
        break;

      case REMOVE_FROM_CONVERSATION_MESSAGES.SUCCESS:
        draft.conversation.messages = action.payload.messages;
        break;

      case SET_CURRENT_CHANNEL:
        draft.currentChannel = action.payload.channelId;
        break;

      case SET_INITIATE_SOCKET_CONNECTION:
        draft.InitiateSocketConnection = action.payload.InitiateSocketConnection;
        break;

      case CLEAR_USER_CONVERSATION:
        draft.conversation.data = {};
        draft.conversation.messages = [];
        break;
      case SET_USER_CONVERSATION_DATA:
        draft.conversation.data = action.payload.data;
        break;

      case SET_NETWORK_STATUS:
        draft.networkStatus = action.payload.data;
        break;

      case UPDATE_SENDING_MESSAGES.SUCCESS:
        if (action.payload.data) draft.conversation.sendingMessages = action.payload.data;
        break;

      case CLEAR_ACTIVE_MESSAGES:
        if (draft.conversation.data.messages) draft.conversation.data.messages = [];
        break;

      case SET_PARENT_INNER_WIDTH:
        draft.parentInnerWidth = action.meta.parentInnerWidth;
        break;

      case SET_POPUP_TO_NOTIFICATION_MESSAGE:
        draft.popupToNotificationMessage = action.payload.message;
        break;

      case SET_INPUT_BOX_STATUS:
        draft.conversation.data.input = action.payload.status;
        break;

      case SET_TIME_SPENT.START:
        draft.timeSpent.loading = true;
        break;

      case SET_TIME_SPENT.SUCCESS:
        draft.timeSpent.loading = false;
        break;

      case SET_TIME_SPENT.ERROR:
        draft.timeSpent.loading = false;
        draft.timeSpent.error = action.payload.error;
        break;

      case SET_AGENT:
        draft.agent.agentId = action.payload.agent && action.payload.agent.id;
        draft.agent.name = action.payload.agent && action.payload.agent.name;
        break;
      case GET_RECENT_GIFS.START:
        draft.gifs.recent.loading = true;
        draft.gifs.recent.data = [];
        break;

      case GET_RECENT_GIFS.SUCCESS:
        draft.gifs.recent.loading = false;
        draft.gifs.recent.data = action.payload.data;
        break;

      case GET_RECENT_GIFS.ERROR:
        draft.gifs.recent.loading = false;
        break;

      case GET_TRENDING_GIFS.START:
        draft.gifs.trending.loading = true;
        break;

      case GET_TRENDING_GIFS.SUCCESS:
        draft.gifs.trending.loading = false;
        draft.gifs.trending.data = [...state.gifs.trending.data, ...action.payload.data.data];
        draft.gifs.trending.pagination = action.payload.data.pagination;
        break;

      case GET_TRENDING_GIFS.ERROR:
        draft.gifs.trending.loading = false;
        break;

      case GET_SEARCHED_GIFS.START:
        draft.gifs.searched.loading = true;
        break;

      case GET_SEARCHED_GIFS.SUCCESS:
        draft.gifs.searched.loading = false;
        if (action.meta.resetQuery) {
          draft.gifs.searched.data = action.payload.data.data;
        } else {
          draft.gifs.searched.data = [...state.gifs.searched.data, ...action.payload.data.data];
        }
        draft.gifs.searched.pagination = action.payload.data.pagination;
        break;

      case GET_SEARCHED_GIFS.ERROR:
        draft.gifs.searched.loading = false;
        break;

      default:
        break;
    }
  });

export default appReducer;
